import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { UserAccess } from '@core/models/user-access.model';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserAccessService {
  private http = inject(HttpClient);

  private baseUrl: string = environment.apiUrl + '/useraccess';

  public getUserAccesss(): Observable<UserAccess> {
    return this.http.get<UserAccess>(`${this.baseUrl}`);
  }

  public upsertUserAccess(userAccess: UserAccess): Observable<UserAccess> {
    return this.http.post<UserAccess>(this.baseUrl, userAccess);
  }
}
